import { endpoints } from '../../../utils/endpoints';
import { fetchJSON } from '../../../utils/fetch';
import { logError } from '../../../utils/logging';
import type { ConfirmCardPaymentType } from './use-stripe-payment';

const get = endpoints();

const FAILURE_RESPONSE = {
  status: 'failure',
  stripeId: '',
};

export const executeCardPayment = async (
  email: string,
  eventSlug: string,
  orderId: number,
  confirmCardPayment?: ConfirmCardPaymentType,
) => {
  const paymentToken = await fetchPaymentToken(eventSlug, orderId);
  if (!paymentToken || !confirmCardPayment) {
    return FAILURE_RESPONSE;
  }

  try {
    const paymentResult = await confirmCardPayment(email, paymentToken);

    if (paymentResult?.error) {
      return FAILURE_RESPONSE;
    }

    return {
      status: paymentResult?.paymentIntent?.status || 'succeeded',
      stripeId: paymentResult?.paymentIntent?.id,
    };
  } catch (e) {
    logError(e as any);
    return FAILURE_RESPONSE;
  }
};

const fetchPaymentToken = async (eventSlug: string, orderId: number) => {
  try {
    const { client_secret } = await fetchJSON(get('PAYMENT_TOKEN')(eventSlug), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
      },
      body: {
        id: orderId,
        event_slug: eventSlug,
      },
    });

    return client_secret;
  } catch (e) {
    return null;
  }
};
